import { LANGUAGE, LANGUAGES, type Language } from '@cmoh/shared'
import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import { initReactI18next } from 'react-i18next'
import { en } from './locales/en/en.index'
import { es } from './locales/es/es.index'

// One-time fix: the old convertDetectedLanguage had a bug that mapped
// browser languages like "en-US" to "es". Only clear the cached value
// when the pattern matches the bug (stored=es but browser=en).
const I18N_FIX_KEY = 'i18n_lang_detection_fix_v2'
if (!localStorage.getItem(I18N_FIX_KEY)) {
  const stored = localStorage.getItem('i18nextLng')
  const browserBase = navigator.language.split('-')[0]
  if (stored === LANGUAGE.ES && browserBase === LANGUAGE.EN) {
    localStorage.removeItem('i18nextLng')
  }
  localStorage.setItem(I18N_FIX_KEY, '1')
}

const resources = {
  en: {
    translation: en,
  },
  es: {
    translation: es,
  },
}

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: LANGUAGE.EN,
    debug: import.meta.env.DEV,

    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng',
      convertDetectedLanguage: (lang) => {
        const base = lang.split('-')[0]
        if (LANGUAGES.includes(base as Language)) return base
        return LANGUAGE.EN
      },
    },

    interpolation: {
      escapeValue: false,
    },
  })

export default i18n
